import { render, staticRenderFns } from "./y_upload_ali_cert.vue?vue&type=template&id=8f655ed2&scoped=true"
import script from "./y_upload_ali_cert.vue?vue&type=script&lang=js"
export * from "./y_upload_ali_cert.vue?vue&type=script&lang=js"
import style1 from "./y_upload_ali_cert.vue?vue&type=style&index=1&id=8f655ed2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f655ed2",
  null
  
)

export default component.exports